<template>
  <section class="full-height-content">
    <div v-if="isLoading && !isInitialDataLoaded" class="content-loading-wrapper">
      <Preloader class="centered-preloader" />
    </div>
    <div v-else class="full-height-content">
      <div v-if="isInitialDataLoaded && getUsers && getUsers.length === 0" class="full-height-content">
        <EmptyStateNoResults @reset-filters="handleResetFilters" />
      </div>
      <TableForPage v-else-if="getUsers && getUsers.length" class="users-table" style="margin-bottom: 0;" :tableData="getUsers || []"
        :isDataLoading="isLoading && isInitialDataLoaded" :fields="fieldsUsers2"
      :slots="userSlots" :isComment="true" :modal-text-editor="true" @update="updateTable">
      <template v-slot:filtersSelect>
        <div class="filters-users">
          <div class="employment-input ml-3">
            <multiselect v-model="employmentType" :options="employmentSelect" :placeholder="'Select'"
              :track-by="'value'" :label="'label'" :allow-empty="false" :showLabels="false" />
          </div>
          <div class="payment-input ml-3">
            <multiselect v-model="paymentType" :options="paymentSelect" :placeholder="'Select'" :track-by="'value'"
              :label="'label'" :allow-empty="false" :showLabels="false" />
          </div>
        </div>
      </template>
      <template v-slot:index="slotProps">
        <IndexColumn :index="slotProps.index" :currentPage="currentPage" :itemsPerPage="perPage"
          :isLoading="isLoading" />
      </template>
      <template v-slot:name="slotProps">
        <TableUserItem :user="slotProps.item" :number="getNumber(slotProps.index)" />
      </template>
      <template v-slot:showOnProfileWidget="slotProps">
        <b-button class="button btn-icon button-checkbox_sm toggle">
          <b-form-checkbox size="sm" switch v-model="slotProps.item.show_on_widget" class="switch switch-bg"
            @change="switchShowOnProfilesWidget(slotProps.item)" />
        </b-button>
      </template>
      <template v-slot:isContactPerson="slotProps">
        <b-button class="button btn-icon button-checkbox_sm toggle">
          <b-form-checkbox size="sm" switch v-model="slotProps.item.is_contact_person" class="switch switch-bg"
            @change="switchContactPersonStatus(slotProps.item)" />
        </b-button>
      </template>
      <template v-slot:roles="slotProps">
        <NoDataText v-if="!slotProps.item.roleName" />
        <template v-else>
          <span v-for="(role, index) in slotProps.item.roles" :key="index"><template v-if="index">, </template>{{
            role.display_name }}</span>
        </template>
      </template>
      <template v-slot:skills="slotProps">
        <template v-if="checkSkillsLength(slotProps.item.skills)">
          <b-tooltip :target="`tooltip-target-${slotProps.index}`" triggers="hover" custom-class="skill-tooltip">
            <div class="user-skills__item" v-for="skill in slotProps.item.skills.slice(2)" :key="skill.id">
              <div class="user-skills-chips d-flex align-items-center">
                {{ skill.name }} <span class="material-icons star">
                  star
                </span> {{ skill.value }}
              </div>
            </div>
          </b-tooltip>
          <div class="user-skills__list p-0">
            <div class="user-skills__item" v-for="skill in slotProps.item.skills.slice(0, 2)" :key="skill.id">
              <div class="user-skills-chips d-flex align-items-center">
                {{ skill.name }} <span class="material-icons star">
                  star
                </span> {{ skill.value }}
              </div>
            </div>
            <div class="user-skills__item" :id="`tooltip-target-${slotProps.index}`"
              :key="`add-skills-count-${slotProps.index}`">
              <div class="user-skills-chips d-flex align-items-center">
                +{{ slotProps.item.skills.slice(2).length }}
              </div>
            </div>
          </div>
        </template>

        <div v-else class="user-skills__list p-0">
          <div class="user-skills__item" v-for="skill in slotProps.item.skills" :key="skill.id">
            <div class="user-skills-chips d-flex align-items-center">
              {{ skill.name }} <span class="material-icons star">
                star
              </span> {{ skill.value }}
            </div>
          </div>
        </div>
      </template>
      <template v-slot:comment="slotProps">
        <div class="user-comment__list p-0">
          <TextEditor :show-text="true" data-already-loaded :entity-type="commentEntityTypes.UserListComment"
            :entity-id="slotProps.item.id" />
        </div>
      </template>
      <template v-slot:status="slotProps">
        <UserStatus :status="slotProps.item.status" :invitation="slotProps.item.actual_invitation"
          @invitationAction="onInvitationStatusClick" :user="slotProps.item" />
      </template>
      <template v-slot:action="slotProps" v-if="$can('read_all-users')">
        <div class="d-flex justify-content-center align-items-center">
          <router-link class="d-flex justify-content-center align-items-center"
            :to="{ name: 'profile', params: { id: slotProps.item.id, type: slotProps.item.type } }">
            <span class="material-symbols-outlined text-editor__block-icon has-comment">
              visibility
            </span>
          </router-link>
            <b-dropdown class="dropdown__theme-light ml-1" right variant="link" toggle-class="text-decoration-none" no-caret boundary="viewport">
        <template v-slot:button-content>
          <span class="action-link_icon" v-html="moreVertIconSvg"></span>
        </template>
        <b-dropdown-item-button :disabled="slotProps.item.type === 'user-profile' || (slotProps.item.status === 'invited' && slotProps.item.is_invitation_expired)" @click.prevent="openTimeOffReportModal(slotProps.item)">
          <span class="dropdown-item-link action-item">
            <span v-html="hourglassBottomIconSvg" class="dropdown-icon mr-1"></span>
            Time off report
          </span>
        </b-dropdown-item-button>
      </b-dropdown>
        </div>
      </template>
      </TableForPage>
    </div>

    <ModalRestoreUser v-model="modalRestoreUser.show" :loading="isDataPageLoading" @submit="restoreUser" />
    <ModalDeleteUser v-model="modalDeletedUser.show" :loading="isDataPageLoading" @submit="deletedUser" />
      <SlideOutContainerViaPortal>
        <div v-if="timeOffReportUserId">
          <TimeOffReportById :isPage="false" :timeOffReportUserId="timeOffReportUserId" :timeOffReportUser="timeOffReportUser" @close="closeTimeOffReport" :breadcrumbs="timeOffReportBreadcrumbs" />
        </div>
      </SlideOutContainerViaPortal>
  </section>
</template>

<script>
import { commentEntityTypes } from '@mocks/comment-entity-types'
import ModalRestoreUser from '@components/modals/ModalRestoreUser'
import ModalDeleteUser from '@components/modals/ModalDeleteUser'
import TableForPage from '@tables/TableForPage'
import TableUserItem from '@components/tables/TableUserItem'
import TextEditor from '@components/TextEditor'
import IndexColumn from '@components/tables/elements/Index'
import { mapActions } from 'vuex'
import Preloader from '@components/Preloader'
import UserStatus from '@/components/UsersInfo/UserStatus'
import { permissions } from '@mocks/permissions'
import NoDataText from '@components/common/NoDataText'
import EmptyStateNoResults from '@components/EmptyStateNoResults'
import hourglassBottomIconSvg from '@/assets/icons/hourglassBottomIcon'
import TimeOffReportById from '@pages/TimeOffReportById.vue'
import SlideOutContainerViaPortal from '@components/transition/SlideOutContainerViaPortal.vue'
import ScrollPositionMixin from '@mixins/ScrollPositionMixin'
import { moreVertIconSvg } from '@/assets/icons/moreVertIcon'

export default {
  name: 'DataUsers',
  mixins: [ScrollPositionMixin],
  components: {
    ModalRestoreUser,
    ModalDeleteUser,
    TableForPage,
    TableUserItem,
    Preloader,
    TextEditor,
    IndexColumn,
    UserStatus,
    NoDataText,
    EmptyStateNoResults,
    TimeOffReportById,
    SlideOutContainerViaPortal
  },
  props: {
    users: {
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: null
    },
    isInitialDataLoaded: {
      type: Boolean,
      default: false
    },
    fieldsUserSkills: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    timeOffReportBreadcrumbs () {
      return [
        {
          text: 'Home',
          click: () => this.closeTimeOffReport()
        },
        {
          text: 'Time off report - detailed',
          to: { name: 'time-off-report' }
        }
      ]
    },
    getAllUsers () {
      if (!this.users || !this.users.length) return []

      return this.users.map((item, index) => {
        return {
          index,
          ...item,
          show_on_widget: item.show_on_widget === 1 || item.show_on_widget === true,
          is_contact_person: item.is_contact_person === 1 || item.is_contact_person === true,
          userStatus: !item.deleted_at && !item.exit_at && item.status === 'approved'
        }
      })
    },
    filterByEmploymentType () {
      let currentUsers = this.getAllUsers

      if (this.employmentType && this.employmentType.value !== 'all') {
        const currentEmploymentType = this.employmentType.value
        currentUsers = currentUsers.filter(user => user.employment_type.type === currentEmploymentType)
      }

      return currentUsers
    },
    filterByPaymentType () {
      let currentUsers = this.filterByEmploymentType

      if (this.paymentType && this.paymentType.value !== 'all') {
        const currentPaymentType = this.paymentType.value
        currentUsers = currentUsers.filter(user => user.payment_type === currentPaymentType)
      }
      return currentUsers
    },
    getUsers () {
      return this.filterByPaymentType || null
    },
    commentEntityTypes () {
      return commentEntityTypes
    }
  },
  data () {
    const commentField = this.$can(permissions.ReadAllComments) ? [
      {
        key: 'comment',
        label: 'Comment',
        class: 'column-long-name'
      }
    ] : []
    return {
      moreVertIconSvg,
      hourglassBottomIconSvg: hourglassBottomIconSvg(),
      currentPage: 1,
      perPage: 15,
      modalRestoreUser: {
        show: false,
        user: null
      },
      modalDeletedUser: {
        show: false,
        user: null
      },
      isWidgetStatusUpdates: false,
      isContactPersonStatusUpdates: false,

      showTd: true,

      fieldsUsers: [
        {
          label: 'Avatar'
        },
        {
          label: 'Name'
        },
        {
          label: 'Email'
        },
        {
          label: 'Roles'
        }
      ],
      fieldsUsers2: [
        {
          key: 'index',
          label: '#',
          sortable: false,
          class: 'number-column'
        },
        {
          key: 'name',
          label: 'User',
          sortable: true,
          class: 'column-long-name'
        },
        {
          key: 'email',
          label: 'Email',
          sortable: true,
          class: 'column-long-email'
        },
        {
          key: 'roles',
          label: 'Roles',
          sortable: true,
          class: 'column-long-roles'
        },
        {
          key: 'showOnProfileWidget',
          label: 'Public',
          class: 'profile-widget-toggle'
        },
        {
          key: 'isContactPerson',
          label: 'Contact',
          class: 'profile-widget-toggle'
        },
        {
          key: 'skills',
          label: 'Skills',
          sortable: true,
          class: 'column-long-roles',
          id: 'tooltip-target-1'
        },
        ...commentField,
        {
          key: 'status',
          label: 'Status',
          sortable: true,
          class: 'column-user-status text-no-wrap'
        },
        {
          key: 'action',
          label: 'Actions',
          class: 'column-controls-md'
        }
      ],
      userSlots: {
        index: {
          name: 'index',
          comment: false
        },
        name: {
          name: 'name',
          comment: false
        },
        avatar: {
          name: 'avatar',
          comment: false
        },
        showOnProfileWidget: {
          name: 'showOnProfileWidget',
          comment: false,
          class: 'profile-widget-toggle'
        },
        isContactPerson: {
          name: 'isContactPerson',
          comment: false,
          class: 'profile-widget-toggle'
        },
        roles: {
          name: 'roles',
          comment: false
        },
        skills: {
          name: 'skills',
          comment: false
        },
        comment: {
          name: 'comment',
          comment: false
        },
        status: {
          name: 'status',
          comment: false
        },
        action: {
          name: 'action',
          comment: false
        }
      },
      employmentSelect: [
        { value: 'all', label: 'All employment types' },
        { value: 'team_member', label: 'Team member' },
        { value: 'independent', label: 'Independent' },
        { value: 'partner', label: 'Partner' }
      ],
      paymentSelect: [
        { value: 'all', label: 'All payment types' },
        { value: 'monthly', label: 'Monthly' },
        { value: 'hourly', label: 'Hourly' }
      ],
      employmentType: { value: 'all', label: 'All employment types' },
      paymentType: { value: 'all', label: 'All payment types' },
      showEditor: false,
      commentEditorOptions: {
        entity_type: commentEntityTypes.UserListComment,
        data_already_loaded: true
      },
      timeOffReportUserId: null,
      timeOffReportUser: null
    }
  },
  async mounted () {
    if (this.$can(permissions.ReadAllComments)) {
      await this.fetchComments({ type: commentEntityTypes.UserListComment })
    }
  },
  methods: {
    ...mapActions({
      fetchComments: 'comments/fetchComments'
    }),
    changeUserStatus (data, user) {
      data ? this.showModalRestoreUser(user) : this.showModalDeletedUser(user)
    },
    switchShowOnProfilesWidget (user) {
      if (!this.isWidgetStatusUpdates) {
        this.isWidgetStatusUpdates = true
        const isShow = !user.show_on_widget || false

        this.axios.put(
          `/api/users/${user.id}/show-on-profiles-widget`,
          {
            userType: user.type,
            showOnWidgetStatus: isShow ? 1 : 0
          },
          {
            headers: {
              Authorization: 'Bearer' + localStorage.getItem('access_token')
            }
          }).then(response => {
          if (response.status === 200) {
            this.$snotify.success('Show on Profiles Widget ' + (isShow ? 'On' : 'Off'), 'Success', this.$store.state.snotify)
          }
        }).catch(err => {
          this.errorNotifications(err)
        }).finally(() => {
          this.isWidgetStatusUpdates = false
        })
      }
    },
    switchContactPersonStatus (user) {
      if (!this.isContactPersonStatusUpdates) {
        this.isContactPersonStatusUpdates = true
        const isContactPerson = !user.is_contact_person || false

        const isUserProfile = user.type === 'user-profile'

        this.axios.put(
          isUserProfile ? `/api/users/profiles/${user.id}/contact-person` : `/api/users/${user.id}/contact-person`,
          {
            isContactPerson: isContactPerson ? 1 : 0
          },
          {
            headers: {
              Authorization: 'Bearer' + localStorage.getItem('access_token')
            }
          }).then(response => {
          if (response.status === 200) {
            this.$snotify.success('Contact Person ' + (isContactPerson ? 'On' : 'Off'), 'Success', this.$store.state.snotify)
          }
        }).catch(err => {
          this.errorNotifications(err)
        }).finally(() => {
          this.isContactPersonStatusUpdates = false
        })
      }
    },
    addItem: function () {
      var formSearch = document.querySelector('.plus-code').innerHTML
      var elemPush = document.querySelector('.formSearch')
      elemPush.innerHTML += '<div>' + formSearch + '</div>'
    },
    showStatuses (e) {
      e.target.parentElement
        .getElementsByClassName('hide-statuses')[0]
        .classList.remove('d-none')
      this.showTd = false
      e.target.classList.add('d-none')
    },
    hideStatuses (e) {
      e.target.parentElement
        .getElementsByClassName('show-statuses')[0]
        .classList.remove('d-none')
      this.showTd = true
      e.target.classList.add('d-none')
    },

    async deleteProfile (e, user) {
      const confirm = await this.$root.$confirm.open(
        'Delete',
        'Are you sure you want to delete profile?'
      )

      if (!confirm) return
      this.axios({
        method: 'delete',
        url: `/api/users/profiles/${user.id}`,
        headers: {
          Authorization: 'Bearer' + this.$store.getters.getAccessToken
        }
      })
        .then(response => {
          if (response.status === 200) {
            this.$snotify.success('Profile successfully deleted.', 'Success', this.$store.state.snotify)
          }
          let profileRow = document.querySelector(`[data-pk="${user.id}"]`)
          if (profileRow) {
            profileRow.remove()
          }
        })
        .catch(err => {
          this.$snotify.error(
            err.response.data.message,
            'Error',
            this.$store.state.snotify
          )
        })
    },

    deletedUser (data) {
      // eslint-disable-next-line camelcase
      const date_exit = this._toLocalTime(data.date.value)

      this._toggleDataPageLoading(() => {
        return this.$api.users
          .deleteUser(this.modalDeletedUser.user.id, { date_exit })
          .then(response => {
            this.modalDeletedUser.user.deleted_at = response.deleted_at
            this.modalDeletedUser.user.exit_at = response.exit_at
            this.$emit('updateUser')
          })
          .catch(err => {
            this.$snotify.error(
              err.response.data.message,
              'Error',
              this.$store.state.snotify
            )
          })
          .finally(() => {
            this.hideModalDeletedUser()
          })
      })
    },
    showModalRestoreUser (user) {
      this.modalRestoreUser.show = true
      this.modalRestoreUser.user = user
    },
    hideRestoreUser () {
      this.modalRestoreUser.show = false
      this.modalRestoreUser.user = null
    },
    showModalDeletedUser (user) {
      this.modalDeletedUser.show = true
      this.modalDeletedUser.user = user
    },
    hideModalDeletedUser () {
      this.modalDeletedUser.show = false
      this.modalDeletedUser.user = null
    },
    restoreUser (data) {
      // eslint-disable-next-line camelcase
      const date_start = this._toLocalTime(data.date.value)

      this._toggleDataPageLoading(() => {
        return this.$api.users
          .restoreUser(this.modalRestoreUser.user.id, { date_start })
          .then(res => {
            this.modalRestoreUser.user.deleted_at = res.deleted_at
            this.modalRestoreUser.user.exit_at = res.exit_at
            this.$emit('updateUser')
          })
          .catch(err => {
            this.$snotify.error(
              err.response.data.message,
              'Error',
              this.$store.state.snotify
            )
          })
          .finally(() => {
            this.hideRestoreUser()
          })
      })
    },
    updateTable (data) {
      this.currentPage = data.currentPage
      this.perPage = data.perPage
    },
    getNumber (index) {
      if (this.currentPage > 1) {
        const curPage = this.currentPage - 1
        return (this.perPage * curPage) + index
      } else {
        return index
      }
    },
    checkSkillsLength (skills) {
      return skills?.length > 2
    },
    async resendInvitation (invitationId, userId) {
      const confirm = await this.$root.$confirm.open(
        'Resend invitation',
        'Do you want to resend the invitation?',
        { submitText: 'Resend', cancelText: 'Close' }
      )

      if (!confirm) return

      this.axios
        .put('/api/user-invitation/resend/' + invitationId,
          {
            headers: {
              Authorization: 'Bearer' + localStorage.getItem('access_token')
            }
          })
        .then(({ data }) => {
          this.$snotify.success(
            data.statusText,
            'Success',
            this.$store.state.snotify
          )
          this.users = this.users.map(user => user.id === userId ? ({ ...user, actual_invitation: data.userInvitation }) : user)
        })
        .catch(error => {
          this.errorNotifications(error)
        })
    },
    async revokeInvitation (invitationId, userId) {
      const confirm = await this.$root.$confirm.open(
        'Revoke invitation',
        'Do you want to revoke the invitation?',
        { submitText: 'Revoke', cancelText: 'Close' }
      )

      if (!confirm) return

      this.axios
        .delete('/api/user-invitation/delete/' + invitationId,
          {
            headers: {
              Authorization: 'Bearer' + localStorage.getItem('access_token')
            }
          })
        .then(async ({ data }) => {
          this.$snotify.success(
            data.statusText,
            'Success',
            this.$store.state.snotify
          )
          this.users = this.users.filter(user => user.id !== userId)
        })
        .catch(error => {
          this.errorNotifications(error)
        })
    },
    async onInvitationStatusClick (invitationId, userId, isInvitationValid) {
      if (isInvitationValid) {
        this.revokeInvitation(invitationId, userId)
      } else {
        this.resendInvitation(invitationId, userId)
      }
    },
    handleResetFilters () {
      this.$emit('reset-filters')
    },
    openTimeOffReportModal (user) {
      const route = this.$router.resolve({
        name: 'time-off-report-id',
        params: {
          id: user.id
        }
      })
      window.history.pushState({}, '', route.href)
      this.timeOffReportUserId = user.id
      this.timeOffReportUser = user
      this.scrollToTheTop()
    },
    closeTimeOffReport () {
      const route = this.$router.resolve({
        name: this.$route.name,
        params: this.$route.params
      })
      window.history.pushState({}, '', route.href)
      this.timeOffReportUserId = null
      this.timeOffReportUser = null
      this.restoreScrollPosition()
    }
  }
}
</script>

<style scoped>
.users-item img {
  margin-right: 15px;
  width: 45px;
  height: 45px;
}

.column-user-name {
  width: 200px;
  padding-left: 0;
}

.users-item-data p span {
  font-weight: 600;
}

.star {
  justify-content: flex-end;
  font-size: 14px;
  display: flex;
  align-items: center;
}

.switch-bg {
  left: -2px;
}

.filters-users {
  top: 0;
  height: fit-content;
  left: 50px;
  display: flex;
  position: absolute;
  bottom: 50px;
  left: 70px;
}

.employment-input {
  width: 172px;
}

.payment-input {
  width: 149px;
}

.toggle {
  background-color: transparent !important;
  border: none;
}

.action-item {
  padding: 7px 12px;
  color: #172B4D;
  font-size: 11px;
  font-weight: 400;
  line-height: 16px;
}

.material-symbols-outlined.text-editor__block-icon {
  width: 20px;
  height: 20px;
  font-size: 20px;
}

::v-deep .dropdown__theme-light .dropdown-toggle {
  width: 20px;
  height: 20px;
  align-items: center;
}

.action-link_icon {
  line-height: 0;
}

</style>
